<form [formGroup]="autoselectFormGroup" class="p-6 pt-4">
    <h3 class="text-xl mb-2">
        {{ 'seasons.season-overview.dialogs.autoselect-applications-dialog.title' | translate }}
    </h3>
    <p class="text-base mb-4">
        {{ 'seasons.season-overview.dialogs.autoselect-applications-dialog.description' | translate }}
    </p>

    <sh-datepicker
        [label]="'seasons.season-overview.dialogs.autoselect-applications-dialog.application-cut-off-date' | translate"
        [value]="autoselectFormGroup.get('applicationCutOffDate')?.value ?? undefined"
        [error]="!!applicationCutOffDateErrorSignal()"
        [errorMessage]="applicationCutOffDateErrorSignal() | translate"
        (value-changed)="onDateChanged($event)"
        format="DDMMYYYY"
        separator="."
    />

    <sh-input-text
        class="mt-4"
        [label]="'seasons.season-overview.dialogs.autoselect-applications-dialog.percentage-label' | translate"
        [value]="autoselectFormGroup.get('percentage')?.value ?? undefined"
        [min]="1"
        [max]="100"
        (value-changed)="onPercentageChanged($event)"
        [error]="!!percentageErrorSignal()"
        [errorMessage]="percentageErrorSignal() | translate"
    />
</form>

<sh-button
    slot="footer"
    color="secondary"
    icon="arrow-line-left-s"
    iconPosition="left"
    size="max-content"
    (clicked)="onClose()"
    [label]="'seasons.season-overview.dialogs.autoselect-applications-dialog.cancel' | translate"
/>
<sh-button
    slot="footer"
    icon="arrow-line-right-s"
    iconPosition="left"
    size="max-content"
    [disabled]="!canConfirm()"
    (clicked)="onClose('confirm')"
    [label]="'seasons.season-overview.dialogs.autoselect-applications-dialog.confirm' | translate"
/>
